






  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { UnitSystem } from '@/interfaces/units';
  import { IPerRoadScenarioImperial, IPerRoadScenarioMetric } from '@/modules/perRoad/interfaces/perRoad';
  import { perRoadStore } from '@/store/store';

  const echarts = require('echarts');

  @Component({
    components: {},
  })
  export default class PrAxleLoadDistributionPlot extends Vue {
    @Prop() scenario!: IPerRoadScenarioImperial | IPerRoadScenarioMetric;

    @Prop({ default: 0 }) id!: number;

    @Prop({ default: 0 }) externalKey!: number;

    // @PropSync('alternative') alt!: ILccaAlternative;
    plotKeyInternal = 0;

    get plotKey() {
      return this.plotKeyInternal + this.externalKey;
    }

    get unitSystemIsImperial() {
      return perRoadStore.displayUnits === UnitSystem.Imperial;
    }

    sync() {
      this.$emit('sync');
    }

    mounted() {
      this.createPlot();
    }

    updated() {
      this.createPlot();
    }

    get plotId() {
      return `axle-load-distribution-plot-${this.id}`;
    }

    createPlot() {
      const el = document.getElementById(this.plotId);
      const chart = echarts.init(el);

      const series = [
        {
          type: 'line',
          name: 'Single',
          data: this.scenario.axleLoadDistSingle.map((wt, i) => [2 * i, wt]),
          animation: false,
        },
        {
          type: 'line',
          name: 'Tandem',
          data: this.scenario.axleLoadDistTandem.map((wt, i) => [2 * i, wt]),
          animation: false,
        },
        {
          type: 'line',
          name: 'Tridem',
          data: this.scenario.axleLoadDistTridem.map((wt, i) => [2 * i, wt]),
          animation: false,
        },
      ];
      console.log(series);

      // Get x max
      const startIndex = 5;
      const xMaxSingle = this.scenario.axleLoadDistSingle.slice(startIndex).findIndex((x) => x === 0) + startIndex;
      const xMaxTandem = this.scenario.axleLoadDistTandem.slice(startIndex).findIndex((x) => x === 0) + startIndex;
      const xMaxTridem = this.scenario.axleLoadDistTridem.slice(startIndex).findIndex((x) => x === 0) + startIndex;

      const xMax = Math.max(xMaxSingle, xMaxTandem, xMaxTridem) * 2;
      // console.log("xmax", xMaxSingle, xMaxTandem, xMaxTridem, Math.max(xMaxSingle, xMaxTandem, xMaxTridem)*2 );

      chart.setOption({
        grid: {
          top: 5,
          right: 5,
          bottom: 45,
          left: 45,
        },
        tooltip: {
          trigger: 'axis',
          formatter(obj: any) {
            return `
<div>${obj[0].seriesName}: ${obj[0].value[1].toFixed(2)}%</div>
<div>${obj[1].seriesName}: ${obj[1].value[1].toFixed(2)}%</div>
<div>${obj[2].seriesName}: ${obj[2].value[1].toFixed(2)}%</div>
`;
          },
        },
        xAxis: {
          name: 'Weight (kip)',
          nameLocation: 'middle',
          nameGap: 30,
          scale: true,
          max: xMax,
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
          },
        },
        yAxis: {
          name: '% AADT',
          nameLocation: 'middle',
          nameGap: 30,
          axisLabel: {
            show: true,
            text: '% AADT',
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series,
      });
    }

  // updatePlotKey() {
  //   this.modulusKey += 1;
  //   console.log('moduluskey', this.modulusKey);
  // }
  }
